import React from "react"
import styled from "styled-components"

import {Card, Row, Col} from "@irati/ui/src/Layout"
import {Http403} from "@irati/ui/src/Errors"

const StyledRow = styled(Row)`
  margin-top: ${({theme}) => theme.spacing.four};
`

export default () => (
  <StyledRow>
    <Col xs={12}>
      <Card>
        <Http403 />
      </Card>
    </Col>
  </StyledRow>
)
